import { useMemo } from "react";
import SectionHeading from "@/components/base/SectionHeading";
import ShortVideoCard from "@/components/feature/ShortVideoCard";
import { shortVideos } from "@/mocks/shortVideos";

export default function LatestShorts() {
  const list = useMemo(
    () =>
      [...shortVideos]
        .sort((a, b) => (a.uploadDate < b.uploadDate ? 1 : -1))
        .slice(0, 4),
    [],
  );

  return (
    <section className="w-full px-4 pt-14 md:px-8 md:pt-20">
      <SectionHeading
        eyebrow="SHORT & LATE"
        title="最新短视频推荐"
        description="三分钟以内的深夜片段，适合在等外卖、等困意、等一个人的时候打开。"
        actionLabel="浏览全部短视频"
        actionTo="/short-videos"
      />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-5 lg:grid-cols-4">
        {list.map((video, index) => (
          <div
            key={video.id}
            className="animate-rise"
            style={{ animationDelay: `${index * 70}ms` }}
          >
            <ShortVideoCard
              id={video.id}
              title={video.title}
              tag={video.tag}
              duration={video.duration}
              views={video.views}
              cover={video.cover}
              uploadDate={video.uploadDate}
            />
          </div>
        ))}
      </div>
    </section>
  );
}